// Spec: docs/plans/frontend-stack.md §3.
//
// apps/admin uses the same stack as apps/web (per CLAUDE.md decision row
// + frontend-stack.md), but does NOT register a skin loader — staff
// portal is modern-only by design (CLAUDE.md MVA scope: 7-action portal,
// no public-facing skin choice). If admin ever needs a skin loader,
// follow the apps/web pattern.

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element not found');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
